import { logError } from './logger';
export const tryParseJSON = (parsable: string) => {
  try {
    return JSON.parse(parsable);
  } catch (error) {
    logError(error);

    return null;
  }
};
